import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubnavMenu } from '~models/subnav-menu';
import { Subscription, combineLatest, Observable, BehaviorSubject } from 'rxjs';
import { Trailer } from '~models/trailer.model';
import { TrailerService } from '~services/trailer.service';
import { TrailerType } from '~v2Models/well.model';
import { Subcarrier } from '~models/subcarrier.model';
import { SubcarrierService } from '~services/subcarrier.service';
import { filter, map } from 'rxjs/operators';
import { UserService } from '~services/user.service';

const SubnavLabels = {
  active: 'Active',
  archived: 'Archived',
};

@Component({
  selector: 'sa-trailer-management',
  templateUrl: './trailer-management.component.html',
  styleUrls: ['./trailer-management.component.scss'],
})
export class TrailerManagementComponent implements OnInit {
  public subnavLabels = SubnavLabels;
  public subnavMenu: SubnavMenu[] = [{ label: this.subnavLabels.active, active: true }];
  public activeMenu = this.subnavLabels.active;

  public trailers$: Observable<Trailer[]>;
  public activeTrailers$: Observable<Trailer[]>;
  public archivedTrailers$: Observable<Trailer[]>;
  public trailerTypes$: Observable<TrailerType[]>;
  public subcarriers$: Observable<Subcarrier[]>;

  public canManageTrailerManagement$ = new BehaviorSubject<boolean>(false);

  constructor(private trailerService: TrailerService, public userService: UserService) {
    this.trailerTypes$ = this.trailerService.trailerTypes$;
    this.trailerService.getTrailerTypes();

    this.subcarriers$ = this.trailerService.subcarriers$;
    this.trailerService.getApLogisticsSubcarriers();

    this.trailers$ = this.trailerService.trailers$;

    this.activeTrailers$ = this.trailers$.pipe(
      map((trailers) => trailers?.filter((trailer) => trailer.archivedTimestamp === null)),
    );

    this.archivedTrailers$ = this.trailers$.pipe(
      map((trailers) => trailers?.filter((trailer) => trailer.archivedTimestamp !== null)),
    );

    this.trailerService.getTrailers();
  }

  ngOnInit(): void {
    this.canManageTrailerManagement$.next(this.userService.hasPermission('trailer_management'));

    this.subnavMenu.push({ label: this.subnavLabels.archived, active: false });
  }
}
